var map = {
	"./promo-spectrespecs_00.jpg": 70,
	"./promo-spectrespecs_01.jpg": 5095,
	"./promo-spectrespecs_02.jpg": 5096,
	"./promo-spectrespecs_03.jpg": 5097,
	"./promo-spectrespecs_04.jpg": 69,
	"./promo-spectrespecs_05.jpg": 5098,
	"./promo-spectrespecs_06.jpg": 5099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5094;